import { loggedInUser } from 'hooks/use-logged-in-user';
import { useTaskService } from 'hooks/services/use-task-service';
import { useQuery } from '@tanstack/react-query';
import { ITaskLookupType } from 'types';

interface TaskStatusesCache {
  taskStatuses: ITaskLookupType[];
  isTaskStatusesLoading: boolean;
  hasTaskStatuses: boolean;
}

export const useTaskStatusesCache = (): TaskStatusesCache => {
  const taskService = useTaskService();
  const { isLoggedIn } = loggedInUser.useController();

  const query = useQuery({
    queryKey: ['taskStatuses'],
    queryFn: () => taskService.getTaskStatuses(),
    staleTime: Infinity,
    enabled: isLoggedIn
  });

  const { isLoading: isTaskStatusesLoading, data: taskStatuses = [] } = query;

  return {
    isTaskStatusesLoading,
    taskStatuses,
    hasTaskStatuses: taskStatuses.length > 0
  };
};
